import React, { createContext, Dispatch, SetStateAction, useContext } from 'react'
import { Descendant } from 'slate'
import { ReactEditor } from 'slate-react'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableTextFeatureFlag } from '@makyoapp/makyo-common'

interface VariableTextContextValue {
  id?: string
  icon?: React.ReactNode
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onChange: (value: Descendant[]) => void
  featureFlags: VariableTextFeatureFlag
  value: Descendant[]
  forceUserSpecific: boolean
  variableColumnOptions: {
    columnTypes: ColumnTypes[]
  }
  editor: ReactEditor
  validation?: (value: Descendant[]) => void
  tableId?: string
  options?: {
    id: string
    label: string
    description?: string
  }[]
  editorId?: string
}

export const VariableTextContext = createContext<VariableTextContextValue>({
  id: undefined,
  open: false,
  setOpen: () => null,
  onChange: () => null,
  value: [],
  featureFlags: 0 as VariableTextFeatureFlag,
  forceUserSpecific: false,
  variableColumnOptions: {
    columnTypes: [],
  },
  editor: {} as ReactEditor,
  validation: undefined,
  tableId: undefined,
  options: undefined,
})

export function useVariableTextContext() {
  return useContext(VariableTextContext)
}
